<!-- please note: the title selector below has to be inside of a div,
      or the link part of this will not receive the proper styling for
      when it's focused for AODA compliance -->
<span class="gb-body2">

  <!-- BUTTON TO TRIGGER TOOLTIP -->
  <a oxTrackLink="'tooltip'" [attr.aria-expanded]="showToolTip"
    [trackDelay]="trackDelay"
    [trackType]="trackType" [prop10]="prop10" [evar33]="evar33" [prop15]="prop15"
    [trackFirstClickOnly]="trackFirstClickOnly" [trackEvent]="trackEvent" (click)="triggerToolTip()"
    role="button" href="javascript:void(0);">

    <!-- TOOLTIP TITLE -->
    <ng-content select=".title"></ng-content>
  </a>

  <!-- CONTENT TO BE SHOWN WHEN TOOLTIP IS TRIGGERED -->
  <span [hidden]="!showToolTip">
    <ng-content select=".content" class="gb-body3"></ng-content>
  </span>

</span>
